import AccountInitialState from "store/preloaded-states/AccountInitialState";
import CartInitialState from "store/preloaded-states/CartInitialState";
import ConfigInitialState from "store/preloaded-states/ConfigInitialState";

export default {
    ...AccountInitialState(),
    ...CartInitialState(),
    ...ConfigInitialState()
}